import type { FC } from 'react'

import { ErrorMessage, Input, Label, Textarea } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import { twJoin } from 'tailwind-merge'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'

import { getClassifications } from '../../new/helpers'
import ClassificationTile from '../../new/steps/step-type/ClassificationTile'
import type { Classification } from '../../new/types'

const Name: FC = () => {
  const translate = useTranslation()

  const classifications = getClassifications(translate)

  return (
    <div className="ecom-policy-name">
      <h2>
        <Translation id="Edit name and description" />
      </h2>

      <Field name="name">
        {({ field, meta }: FieldProps) => (
          <Input
            isFullWidth
            id="name"
            label={<Translation id="Name" />}
            type="text"
            marginBottom={16}
            error={meta.error}
            touched={meta.touched}
            {...field}
          />
        )}
      </Field>

      <Field name="description">
        {({ field, meta }: FieldProps) => (
          <Textarea
            isFullWidth
            id="description"
            type="text"
            label={<Translation id="Description" />}
            marginBottom={16}
            error={meta.error}
            touched={meta.touched}
            {...field}
          />
        )}
      </Field>

      <Field name="classificationList">
        {({ field, meta, form }: FieldProps) => (
          <>
            <Label>{translate('Policy Type')}</Label>
            <div
              className={twJoin(
                'mb-2 grid gap-2 rounded-lg border border-solid p-2 sm:grid-cols-1 md:grid-cols-3',
                !meta.error && 'border-stone-300',
                meta.error && 'shadow-error border-red-500 bg-red-100'
              )}
            >
              {classifications.map(classificationsListItem => (
                <ClassificationTile
                  key={classificationsListItem.symbol}
                  symbol={classificationsListItem.symbol}
                  label={classificationsListItem.label}
                  selectedClassifications={field.value}
                  setSelectedClassifications={(classification: Classification[] | null) => {
                    form.setFieldValue('classificationList', classification)
                  }}
                  size="sm"
                />
              ))}
            </div>
            {meta.error && meta.touched && <ErrorMessage>{meta.error}</ErrorMessage>}
          </>
        )}
      </Field>
    </div>
  )
}

export default Name
